type MapContentType = 'task' | 'image' | 'area' | 'zone';

const PANEL_BARS: Record<
  MapContentType,
  { panelBarId: string; listPrefix: string }
> = {
  task: { panelBarId: 'task-panel-bar', listPrefix: 'taskList-' },
  image: { panelBarId: 'image-panel-bar', listPrefix: 'imageList-' },
  area: { panelBarId: 'area-panel-bar', listPrefix: 'areaList-' },
  zone: { panelBarId: 'zone-panel-bar', listPrefix: 'zoneList-' }
};

const ANIMATION_DELAY = 200;
const BLIP_DURATION = 1000;

let pendingTimers: number[] = [];

const later = (fn: () => void, ms: number) => {
  pendingTimers.push(window.setTimeout(fn, ms));
};

const cancelPending = () => {
  pendingTimers.forEach(clearTimeout);
  pendingTimers = [];
};

const isExpanded = (el: HTMLElement) =>
  el.getAttribute('aria-expanded') === 'true' ||
  el.classList.contains('k-expanded');

const expandPanel = (el: HTMLElement): boolean => {
  const wasExpanded = isExpanded(el);
  if (!wasExpanded)
    el.querySelector<HTMLElement>('.k-panelbar-header .k-link')?.click();

  return wasExpanded;
};

// reset the previous highlight when designer click another object on map
const resetHighlights = () => {
  Object.values(PANEL_BARS).forEach(({ panelBarId, listPrefix }) => {
    document
      .querySelectorAll(`#${panelBarId} [id^="${listPrefix}"]`)
      .forEach((el) => {
        el.classList.remove('blip-map-content');
        el.classList.add('border-0');
      });
  });
};

export const mapContentHighlight = (type: MapContentType, itemId: string) => {
  const { panelBarId, listPrefix } = PANEL_BARS[type];

  // get the Map Content Panel Bar element
  const contents = document.getElementById('contents');
  if (!contents) return;

  cancelPending();
  resetHighlights();

  // expand the Map Content Panel Bar first
  const contentsWasExpanded = expandPanel(contents);

  later(
    () => {
      const panelBar = document.getElementById(panelBarId);
      if (!panelBar) return;

      // expand the item Panel Bar (task, zone, area, or image) first
      const panelWasExpanded = expandPanel(panelBar);

      later(
        () => {
          const list = panelBar.querySelector('.k-animation-container');
          if (!list) return;

          const targetId = `${listPrefix}${itemId}`;

          Array.from(list.children).forEach((container) => {
            const target = container.querySelector(`[id^="${listPrefix}"]`);
            if (!target) return;

            if (target.id === targetId) {
              target.classList.add('blip-map-content');
              target.classList.remove('border-0');
              later(
                () => target.classList.remove('blip-map-content'),
                BLIP_DURATION
              );
              target.scrollIntoView({ behavior: 'smooth' });
            } else {
              target.classList.add('border-0');
            }
          });
        },
        // if already expanded, the delay not needed
        panelWasExpanded ? 0 : ANIMATION_DELAY
      );
    },
    // if already expanded, the delay not needed
    contentsWasExpanded ? 0 : ANIMATION_DELAY
  );
};
